<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-12">
        <h3 class="title m-t-10 m-l-15">Test library</h3>
        <ol class="breadcrumb" style="margin-top: -20px">
          <li class="breadcrumb-item"><a href="/"><i class="mdi mdi-home"></i> На головну</a></li>
          <li class="breadcrumb-item" v-if="getBook">
            <a :href="`/library/description/${getBook.id}`">
              {{ getBook.title }}
            </a>
          </li>
          <li class="breadcrumb-item active" v-if="audioBook">Редагування електронної книги "{{ audioBook.name }}"</li>
        </ol>
      </div>
    </div>
    <AudioIndexComponent />
  </div>
</template>

<script>
import AudioIndexComponent from './AudioBook/AudioBookIndex/AudioIndexComponent';
import * as audioBookActions from "../store/modules/AudioBook/types/actions";
import {mapActions, mapGetters} from "vuex";
import * as audioBookGetters from "../store/modules/AudioBook/types/getters";

export default {
  name: "AudioBookIndex",
  components: {
    AudioIndexComponent
  },
  computed: {
    ...mapGetters('AudioBook', {
      audioBook: audioBookGetters.GET_AUDIO_BOOK
    }),
    getBook() {
      return this.audioBook ? this.audioBook.book : {}
    }
  },
  methods: {
    ...mapActions('AudioBook', {
      getAudioBook: audioBookActions.GET_AUDIO_BOOK
    })
  },
  mounted() {
    try {
      this.getAudioBook(this.$route.params.id);
    } catch (err) {
      console.log(err);
    }
  }
}
</script>